import { Component, OnInit, OnChanges, SimpleChange, Input } from '@angular/core';
import { Router } from '@angular/router';

import { NotificationService } from '../../../../../core/services/notification.service';
import { ConfigService } from '../../../../../core/services/config.service';

import { CommunicationService } from '../communication.service';
import { CommunicationDetails } from './communication-details.model';
import { UtilService } from '../../../../../core/services/util.service';

@Component({
  selector: 'itpx-communication-add',
  templateUrl: './communication-add.component.html',
  styleUrls: ['./communication-add.component.css']
})
export class CommunicationAddComponent implements OnInit {

    private details: CommunicationDetails = new CommunicationDetails();
    private countries: any = [];
    private domains: any = [];
    private codeCountryList: any = {};
    private patternList: any = {};
    private pattern: string = '.+';
    private countryCode: string;
    private states: any = [];
    private showStates: boolean = false;
    private isInProgress: boolean = false;

    constructor(
        private service: CommunicationService,
        private configService: ConfigService,
        private notificationService: NotificationService,
        private router: Router,
        private utilService: UtilService
    ) { }

    ngOnInit() {
        this.service.getCountries()
            .subscribe(
                body => this.countries = this.formatDict(body.data).reverse(),
            );
        this.service.getPatternCodeList()
            .subscribe(
                body => this.patternList = body.data,
            );
        this.service.getDomains()
            .subscribe(
                body => this.domains = body.data,
            );

        this.details.primaryAddress = false;
    }

    private save() {
        this.service.addCommunication(this.details)
            .subscribe(
                body => {
                    this.notificationService.success('Successfully created communication data',  'Success');
                    this.router.navigate(['/agora/account-data/communication/']);
;                }
            );
    }

    private onPhoneNumbersChange(phoneNumbers: any[]) {
        this.details.phoneNumbers = phoneNumbers;
    }
    
    private formatDict(obj: any) {
        this.codeCountryList = obj;
        let result = [];
        for (let prop in obj) {
            if(obj.hasOwnProperty(prop)) {
                result.push({key: prop, value: obj[prop]});
            }
        }
        return result;
    }
    private getPatternByCountry(country): string {
        for (let prop in this.codeCountryList) {
            if (this.codeCountryList.hasOwnProperty(prop)) {
                if (prop.indexOf(country) !== -1) {
                    return this.getPatternByCode(prop);
                }
            }
        }
    }
    private getPatternByCode(code): string {
        for (let obj in this.patternList) {
            if (this.patternList[obj]['key'] == code) {
                return this.patternList[obj]['pattern'];
            }
        }
    }

    private onChangeCountry(event) {
        if(event) {
            this.details.country = event;
            this.details.zipCode = undefined;
            this.pattern = this.getPatternByCountry(event);
            this.updateStates();
        }
    }

    private updateStates() {
        delete this.details.state;
        this.showStates = false;
        if(this.details.country) {
            this.service.getStatesByCountry(this.details.country)
                .subscribe(
                    body => {
                        this.states = body.data;
                        if(this.states.length)
                            this.showStates = true;
                    },
                    err => {
                        this.states = [];
                    }
                );
        } else {
            this.states = [];
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/agora/components/account-data/communication/add/communication-add.component.ts